import Slider from '../slider';

export default () => {
  const slider = new Slider({
    wrapper: '.pluses-wrapper',
    slide: '.pluses-slide',
    btnNext: '.pluses-btn--next',
    btnPrev: '.pluses-btn--prev',
    infinite: false,
    disableBtnClass: 'pluses-btn--disabled',
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/pluses/index.js